import { render, staticRenderFns } from "./SelectAttorney.vue?vue&type=template&id=09c9c23a&"
import script from "./SelectAttorney.vue?vue&type=script&lang=js&"
export * from "./SelectAttorney.vue?vue&type=script&lang=js&"
import style0 from "./SelectAttorney.vue?vue&type=style&index=0&id=09c9c23a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports